import { apiClient, API_ENDPOINTS } from '../../../config/api';
import type {
  CupidCardAdminStatsDto,
  CupidCardBatchResultDto,
  CupidCardAdminListDto,
  CupidCardAdminDetailDto,
  HeartGrantResultDto,
  AdminCupidCardPageDto,
  ManualIssueCardRequest,
  ManualIssueCardResultDto,
} from '../../../types';

export async function fetchCupidCardStats(week?: string): Promise<CupidCardAdminStatsDto> {
  const qs = week ? `?week=${encodeURIComponent(week)}` : '';
  const res = await apiClient.get<{ result: CupidCardAdminStatsDto; resultType: string }>(
    `${API_ENDPOINTS.ADMIN.CUPID_CARDS.STATS}${qs}`
  );
  return res.result;
}

export async function fetchCupidCardBatchResult(week?: string): Promise<CupidCardBatchResultDto> {
  const qs = week ? `?week=${encodeURIComponent(week)}` : '';
  const res = await apiClient.get<{ result: CupidCardBatchResultDto; resultType: string }>(
    `${API_ENDPOINTS.ADMIN.CUPID_CARDS.BATCH_RESULTS}${qs}`
  );
  return res.result;
}

export interface CupidCardListFilter {
  status?: string;
  week?: string;
  opened?: boolean;
  extended?: boolean;
  searchKeyword?: string;
  page?: number;
  size?: number;
}

export async function fetchCupidCards(filter: CupidCardListFilter = {}): Promise<AdminCupidCardPageDto> {
  const params = new URLSearchParams();
  if (filter.status && filter.status !== '전체') params.append('status', filter.status);
  if (filter.week && filter.week !== '이번 주') params.append('week', filter.week);
  if (filter.opened !== undefined) params.append('opened', String(filter.opened));
  if (filter.extended !== undefined) params.append('extended', String(filter.extended));
  if (filter.searchKeyword?.trim()) params.append('searchKeyword', filter.searchKeyword.trim());
  params.append('page', String(filter.page ?? 0));
  params.append('size', String(filter.size ?? 20));

  const qs = params.toString() ? `?${params.toString()}` : '';
  const res = await apiClient.get<{ result: AdminCupidCardPageDto; resultType: string }>(
    `${API_ENDPOINTS.ADMIN.CUPID_CARDS.LIST}${qs}`
  );
  return res.result;
}

export async function fetchCupidCardDetail(cardId: number): Promise<CupidCardAdminDetailDto> {
  const res = await apiClient.get<{ result: CupidCardAdminDetailDto; resultType: string }>(
    API_ENDPOINTS.ADMIN.CUPID_CARDS.DETAIL(cardId)
  );
  return res.result;
}

export async function forceExpireCard(cardId: number, reason: string): Promise<CupidCardAdminDetailDto> {
  const res = await apiClient.post<{ result: CupidCardAdminDetailDto; resultType: string }>(
    API_ENDPOINTS.ADMIN.CUPID_CARDS.FORCE_EXPIRE(cardId),
    { reason }
  );
  return res.result;
}

export async function grantHearts(
  userId: number,
  amount: number,
  reason: string
): Promise<HeartGrantResultDto> {
  const res = await apiClient.post<{ result: HeartGrantResultDto; resultType: string }>(
    API_ENDPOINTS.ADMIN.HEARTS.GRANT(userId),
    { amount, reason }
  );
  return res.result;
}

export async function issueCardManually(
  request: ManualIssueCardRequest
): Promise<ManualIssueCardResultDto> {
  const res = await apiClient.post<{ result: ManualIssueCardResultDto; resultType: string }>(
    API_ENDPOINTS.ADMIN.CUPID_CARDS.MANUAL_ISSUE,
    request
  );
  return res.result;
}
